import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  advancedSearch: {
    description: 'shipping.nav.advancedSearch',
    defaultMessage: 'Advanced Search',
    id: 'gGCilO',
  },
});
